export const MAX_AVATAR_BYTES = 5 * 1024 * 1024;
export const AVATAR_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'] as const;

export type AvatarValidationCode = 'invalid-type' | 'too-large';

export class AvatarUploadError extends Error {
  constructor(
    public readonly code: AvatarValidationCode | 'upload-failed',
    message: string,
    cause?: unknown
  ) {
    super(message);
    this.name = 'AvatarUploadError';
    if (cause !== undefined) Object.assign(this, { cause });
  }
}

export const validateAvatarFile = (file: Pick<File, 'type' | 'size'>): void => {
  if (!AVATAR_MIME_TYPES.includes(file.type as (typeof AVATAR_MIME_TYPES)[number])) {
    throw new AvatarUploadError('invalid-type', 'Choose a JPEG, PNG or WebP image.');
  }
  if (file.size > MAX_AVATAR_BYTES) {
    throw new AvatarUploadError('too-large', 'Choose an image smaller than 5 MB.');
  }
};
